
























































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { date, format } from 'quasar'
import PdfViewer from 'components/PdfViewer.vue'
import ModalDialog from 'components/modals/Dialog.vue'
import confirm from 'components/modals/Confirm'
import api from 'src/assets/api/gql'
import ItemAttachmentDelete from 'src/graphql/item/ItemAttachmentDelete.gql'

@Component({
  components: {
    PdfViewer,
    ModalDialog
  }
})
export default class ItemFileFolderCard extends Vue {
  removing = false

  @Prop()
  readonly file!: Json

  @Ref()
  readonly dialog!: ModalDialog

  get extension () {
    const match = this.file.src.match(/\.(?<ext>[a-z]+)$/i)
    return match?.groups?.ext?.toLowerCase()
  }

  get pdf () {
    return 'pdf' === this.extension
  }

  get text () {
    return 'txt' === this.extension
  }

  get office () {
    if (['docx', 'pptx', 'xlsx', 'doc', 'ppt', 'xls'].includes(this.extension)) {
      if (this.file.src.startsWith('/')) {
        // return 'https://docs.google.com/gview?url=https://quizenter.com' + this.file.src + '&embedded=true'
        return 'https://view.officeapps.live.com/op/embed.aspx?src=https://quizenter.com' + this.file.src
      } else {
        try {
          const url = new URL(this.file.src)
          // return 'https://docs.google.com/gview?url=' + this.file.src + '&embedded=true'
          return 'https://view.officeapps.live.com/op/embed.aspx?src=' + this.file.src
        } catch (e) {}
      }
    }
  }

  get image () {
    return this.file.type.includes('image')
  }

  get name () {
    return this.file.src.match(/^(\/\d+)+\/.{36}\.(?<name>.+)/)?.groups.name
  }

  get time () {
    const { formatDate } = date
    return formatDate(this.file.createdAt, 'D MMM \'YY HH:mm')
  }

  get size () {
    const { humanStorageSize } = format
    return humanStorageSize(this.file.size)
  }

  download () {
    this.dialog.hide()
    const a = document.createElement('a')
    a.style.display = 'none';
    document.body.appendChild(a)
    a.href = this.file.src
    a.setAttribute('download', this.name)
    a.setAttribute('target', '_blank')
    a.click()
    document.body.removeChild(a)
  }

  async remove () {
    this.dialog.hide()
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: this.name
    })
    this.removing = true
    await api.mutate({
      query: ItemAttachmentDelete,
      variables: { input: { id: this.file.id } }
    })
    this.removing = false
    this.$emit('remove')
  }
}
